import { FormDialog } from '@/components/ui/form-dialog';
import { useTranslation } from '@hooks/useTranslation';
import { CreateUserForm } from './CreateUserForm';
import type { CurrentUser } from '../../lib/capabilities';
import type { SlingPosition } from '@api/users';

interface CreateUserDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentUser?: CurrentUser;
  slingPositions: SlingPosition[];
}

export function CreateUserDialog({ open, onOpenChange, currentUser, slingPositions }: CreateUserDialogProps) {
  const { t } = useTranslation();

  return (
    <FormDialog open={open} onOpenChange={onOpenChange} title={t('dialog.title')}>
      {({ reportPending, close }) => (
        <CreateUserForm
          onPendingChange={reportPending}
          onSuccess={close}
          currentUser={currentUser}
          slingPositions={slingPositions}
        />
      )}
    </FormDialog>
  );
}
